import { Calendar } from "lucide-react";
import { projectCategories, formatMonthYear } from "@/lib/project";

// Card visual condivisa tra homepage teaser e pagina /progetti.
// Props:
//   project: oggetto progetto dall'API
//   onClick: handler click sulla card
//   testId: opzionale, per data-testid
export default function ProgettoCard({ project, onClick, testId }) {
  const image = project.cover_image_url || project.immagini?.[0]?.image_url;
  if (!image) return null;

  const galleryCount = project.immagini?.length || 0;
  const cats = projectCategories(project);

  return (
    <div
      className="group relative cursor-pointer overflow-hidden rounded-2xl bg-white shadow-sm hover:shadow-xl transition-shadow"
      onClick={onClick}
      data-testid={testId}
    >
      <div className="aspect-[4/3] overflow-hidden">
        <img
          src={image}
          alt={project.titolo}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
      </div>

      {galleryCount > 1 && (
        <div className="absolute top-3 right-3 bg-black/60 text-white text-xs px-2 py-1 rounded-full">
          {galleryCount} foto
        </div>
      )}

      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

      <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
        <div className="flex flex-wrap gap-1 mb-2">
          {cats.map((cat) => (
            <span
              key={cat}
              className="inline-block px-3 py-1 bg-[#FF9500] text-white text-xs font-semibold rounded-full"
            >
              {cat}
            </span>
          ))}
        </div>
        <h3 className="text-white text-lg font-bold">{project.titolo}</h3>
        {project.data_installazione && (
          <p className="text-white/80 text-xs mt-1 flex items-center gap-1">
            <Calendar className="w-3 h-3" />
            {formatMonthYear(project.data_installazione)}
          </p>
        )}
      </div>
    </div>
  );
}
